// ClientV2's phone / desktop boundary, for the parts styled with MUI `sx`.
//
// At or below it the smart filter is a slide-out sheet (placed by
// `.clientv2-filter-sidebar` in styles.scss) and the list takes the width;
// above it the filter is an in-flow column. The SCSS side reads the same number
// from `$clientv2-sheet-max`, and __tests__/clientLayout.test.ts fails if the
// two ever differ — a close button or card frame keyed to one boundary and a
// sheet keyed to another would show the wrong one in between.

export const CLIENTV2_SHEET_MAX_WIDTH = 900;

/** The phone layout, where the filter panel is the sheet's content. */
export const SHEET_MEDIA = `@media (max-width: ${CLIENTV2_SHEET_MAX_WIDTH}px)`;

/**
 * Its complement. Prefer it for "phone only" controls, written as "hide on
 * desktop": jsdom ignores media queries, so a control hidden by default would
 * vanish from every test.
 */
export const DESKTOP_MEDIA = `@media (min-width: ${CLIENTV2_SHEET_MAX_WIDTH + 1}px)`;
